
export default {
  name: 'MegasredaContentProductGridCard',
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSetShow: false,
    }
  },
  computed: {
    author() {
      const author = Array.isArray(this.product?.author)
        ? this.product?.author[0]
        : this.product?.author
      return author
    },
    price() {
      switch (this.product.price?.priceDisplay) {
        case 'FREE':
          return 'Бесплатно'
        case 'AGREEMENT':
          return 'По договорённости'
        case 'EXACT':
          return `${new Intl.NumberFormat('ru-Ru').format(
            this.product.price?.exactPrice
          )}\u00A0₽`
        case 'RANGE':
          return this.product.price?.rangeEndPrice
            ? `От ${new Intl.NumberFormat('ru-Ru').format(
                this.product.price?.rangeStartPrice
              )}\u00A0₽. до ${new Intl.NumberFormat('ru-Ru').format(
                this.product.price?.rangeEndPrice
              )}\u00A0₽.`
            : `От ${new Intl.NumberFormat('ru-Ru').format(
                this.product.price?.rangeStartPrice
              )}\u00A0₽.`
        default:
          return null
      }
    },
    oldPrice() {
      return this.product.price?.oldPrice
    },
  },
  methods: {
    inView({ isInView }) {
      if (isInView && !this.isSetShow) {
        this.setShow()
      }
    },
    setShow() {
      this.$axios.$post('/activity/show/advertisement', {
        username: this.author.username,
        advertisementId: this.product._id,
      })
      this.isSetShow = true
    },
  },
}
